// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__N7C8q","imageCntr":"style_imageCntr__BQd7l","info":"style_info__a9Dcv","dates":"style_dates__pkHCi"};